<template>
  <div class="partners">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h3 class="section-title">Our Partners</h3>
          <p
            class="text-justify"
          >Our sole primary objective is to provide effective tailor-made media solutions for our valued clients. We understand that media planning is the key to strategic & efficient media planning.</p>
        </div>
        <div class="col-md-8">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="item in slideItems" :key="item">
              <img :src="'/images/ourpartners/' +item" alt />
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
        autoplay: { delay: 1500 },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      slideItems: [
        "abc.jpg",
        "ap1.jpg",
        "avenues.jpg",
        "bhaktidarshan.jpg",
        "btv.jpg",
        "business plus.jpg",
        "channel nepal.jpg",
        "Himalaya.jpg",
        "image channel.jpg",
        "janata tv.jpg",
        "kantipur.jpg",
        "krishi tv.jpg",
        "mountain.jpg",
        "nepal1.jpg",
        "news24.jpg",
        "ntv.jpg",
        "ntvplus.jpg",
        "prime times.jpg",
        "sagarmatha.jpg",
        "tv today.jpg",
        "tvfilmy.jpg"
      ]
    };
  }
};
</script>


<style scoped>
.partners {
  padding: 60px 0;
  background: #f5f5f5;
}
</style>